<script>
import appConfig from "@/app.config";

import Testimonials from "@/components/testimonials/Testimonials.vue";
import Recommendation from "@/components/recommendation/Recommendation.vue";
import HelpSupport from "@/components/HelpSupport.vue";
import GameLearnPlaySlider from "@/components/gameLearn&playSlider/index.vue";
import GooglePlay from "@/components/svg/icons/GooglePlay.vue";
import AppleStore from "@/components/svg/icons/AppleStore.vue";
import AmazonStore from "@/components/svg/icons/AmazonStore.vue";
import { gsap, random } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import {
  isMobile,
  isTablet,
  isAndroid,
  isIOS,
  browserName,
} from "mobile-device-detect";

export default {
  components: {
    GooglePlay,
    AppleStore,
    AmazonStore,
  },
  props: {
    showLoadingScreen: Boolean,
    featuredData: Object,
  },
  watch: {
    showLoadingScreen(newVal, oldVal) {
      if (!newVal) {
        this.mobileScale();
        this.gspLoad();
      }
    },
    featuredData(newVal) {
      console.warn("数据是", newVal);
      this.newData = newVal;
      this.newData.blackApps = this.blackApps;
      this.newData.whiteApps = this.whiteApps;
    },
  },
  data() {
    return {
      assetsPath: appConfig.assetsPath,
      browsers: appConfig.browsers,
      number: 1,
      newData: {},
      isMobile,
      isTablet,
      browserName,
      isAndroid,
      isIOS,
      showVideos: false,
      blackApps: ["apple", "google", "amazon", "andrdiod"],
      whiteApps: ["apple", "google", "amazon", "andrdiod"],
    };
  },
  methods: {
    defaultload() {},
    getVideoUrl(url) {
      if (url) {
        if (url.indexOf("http") > -1) {
          return url;
        }
        return this.assetsPath + url + ".mp4";
      }
      return "";
    },
    getImgUrl(img) {
      if (img) {
        if (img.indexOf("http") > -1) {
          return img;
        }
        return this.assetsPath + "images/" + img;
      }
      return "";
    },
    gspLoad() {
      // *** Animation  ***
      const wHeight = window.innerHeight;
      gsap.registerPlugin(ScrollTrigger);
      gsap.defaults({ duration: 2 });

      const w = this.$refs.iPhoneModel.clientWidth;
      const h = this.$refs.iPhoneModel.clientHeight;

      var scale = Math.min(window.innerWidth / w, window.innerHeight / h);

      const tl = gsap.timeline();
      tl.to("#heroContent", { y: -800, delay: 0.2 })
        .to("#heroContent", { opacity: 0 }, "-=2")
        .to("#mouse-scroll", { y: 100, opacity: 0, duration: 0.5 }, "-=2")
        .to("#homeHeroTrigger", { opacity: 0, display: "none" }, "-=2");

      ScrollTrigger.create({
        animation: tl,
        trigger: "#learnPlayVideoBlock",
        start: "0 77px",
        end: "+=" + wHeight * 2 + "",
        scrub: 0.5,
        // markers: true,
        pin: "#videoblockPin",
        //triggerActions: " restart pause reverse pause"
        //stagger: .2 // for childs delay
      });

      let ySpace = -100;
      if (window.innerWidth < 500) {
        ySpace = -10;
      }

      const tl1 = gsap.timeline();
      tl1
        .from("#iPhoneModel", { y: ySpace })
        .to("#iPhoneModel", { scale: 1, left: "auto" }, "-=1.2");
      ScrollTrigger.create({
        animation: tl1,
        trigger: "#learnPlayVideoBlock",
        start: "0 77px",
        end: "+=" + wHeight * 2 + "",
        scrub: 0.5,
        // markers: true,
        pin: "#videoblockPin",
      });

      const tl2 = gsap.timeline();
      tl2.to("#mouse-scroll", { y: 20, repeat: -1, yoyo: true });
    },
    mobileScale() {
      const w = this.$refs.iPhoneModel.clientWidth;
      const h = this.$refs.iPhoneModel.clientHeight;
      let extraHeight = 1;
      if (window.innerWidth < 500) {
        extraHeight = 2;
      }
      var scale = Math.min(
        // window.innerWidth / w,
        window.innerHeight / h + extraHeight
      );
      let extraScale = 0.5;
      this.$refs.iPhoneModel.style.transform =
        "scale(" + (scale + extraScale) + ")";
    },
    onResize() {
      //   this.mobileScale();
    },
    checkBrowser() {
      const isFound = this.browsers.find(
        (browser) => browser.name == this.browserName
      );
      if (isFound && (this.isMobile || this.isTablet)) {
        this.showVideos = false;
      } else {
        this.showVideos = true;
      }
    },
  },
  created: function () {
    this.newData = this.featuredData;
    this.newData.blackApps = this.blackApps;
    this.newData.whiteApps = this.whiteApps;
  },
  mounted() {
    window.addEventListener("resize", this.onResize, { passive: true });
    this.mobileScale();
    this.checkBrowser();
  },
  updated() {
    this.number = Math.floor(Math.random() * 100);
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
};
</script>

<template>
  <div class="overflow-hidden">
    <span :class="$style.numberPlaceholder"
      >{{ number }}{{ this.$i18n.locale }}</span
    >
    <div :class="$style.learnPlay" class="d-flex" id="learnPlayVideoBlock">
      <div
        class="w-100 p-rel"
        id="homeHeroTrigger"
        :class="$style.homeHeroTrigger"
      >
        <div id="homeHeroPin" style="z-index: 1">
          <div :class="$style.homeHero" class="d-flex">
            <b-container class="p-rel">
              <div :class="$style.heroContent" id="heroContent">
                <div class="d-flex mt-5" />
                <h2
                  class="heading-2 mb-4"
                  v-if="
                    newData &&
                    newData.title &&
                    newData.title.indexOf('Panda') > -1
                  "
                >
                  Dr. Panda
                  <span class="nowrap">{{
                    newData.title ? newData.title.split("Panda")[1] : ""
                  }}</span>
                </h2>
                <h2 class="heading-2 mb-4" v-else>
                  {{ newData.title }}
                </h2>
                <p class="px-lg-5 d-inline-block" id="child_2">
                  <span
                    class="
                      px-lg-4
                      d-none
                      d-md-inline-block
                      d-lg-inline-block
                      d-xl-inline-block
                    "
                  >
                    {{ newData.abstract }}
                  </span>
                  <span class="px-lg-4 d-inline-block d-md-none d-lg-none">
                    {{ newData.abstract }}
                  </span>
                </p>
                <div
                  :class="$style.storeBadge"
                  class="d-flex justify-content-center"
                  id="child_3"
                >
                  <div v-for="(app, index) in newData.whiteApps" :key="index">
                    <a
                      target="_blank"
                      :href="newData.appStore"
                      v-if="newData.appStore"
                    >
                      <img
                        :src="assetsPath + 'images/apple-app@2x.png'"
                        v-if="
                          app == 'apple' && ((isMobile && isIOS) || !isMobile)
                        "
                      />
                    </a>
                    <a
                      target="_blank"
                      :href="newData.googlePlay"
                      v-if="newData.googlePlay"
                    >
                      <img
                        :src="assetsPath + 'images/google-play-app@2x.png'"
                        v-if="
                          app == 'google' &&
                          ((isMobile && isAndroid) || !isMobile)
                        "
                      />
                    </a>
                    <a
                      target="_blank"
                      :href="newData.amazonStore"
                      v-if="newData.amazonStore"
                    >
                      <img
                        :src="assetsPath + 'images/amazon-white@2x.png'"
                        v-if="app == 'amazon' && !isMobile"
                      />
                    </a>
                    <a
                      target="_blank"
                      :href="newData.andrdiodStore"
                      v-if="newData.andrdiodStore"
                    >
                      <img
                        class="andrdiodButton"
                        v-if="
                          app == 'andrdiod' &&
                          ((isAndroid && isMobile) || !isMobile)
                        "
                        src="https://preview-web.xiongmaoboshi.com/resource/cms/image/Android-CN%20_white1-1604560214352-999.png"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </b-container>
            <!--  -->

            <a class="mouse-scroll" href="javascript:" id="mouse-scroll">
              <span class="mouse-scroll__mouse" aria-hidden="true">
                <span
                  class="
                    mouse-scroll__mouse__wheel mouse-scroll__mouse__wheel--1
                  "
                ></span>
                <span
                  class="
                    mouse-scroll__mouse__wheel mouse-scroll__mouse__wheel--2
                  "
                ></span>
              </span>
              <span class="mouse-scroll__label">Scroll for more</span>
            </a>

            <!--  -->
          </div>
        </div>
      </div>
      <b-container>
        <div :class="$style.centerBlock" class="text-center">
          <div class="w-100 d-inline-block">
            <div id="videoblockPin">
              <div :class="$style.photos" class="d-flex mb-5">
                <div
                  :class="[
                    $style.iPadModel,
                    showVideos ? '' : $style.hideBlackLayer,
                  ]"
                >
                  <video
                    width="320"
                    height="240"
                    preload="auto"
                    muted
                    autoplay
                    loop
                    playsinline
                    :class="$style.videoPlayer"
                    :poster="getImgUrl(newData.cover)"
                    v-if="showVideos"
                  >
                    <source
                      :src="getVideoUrl(newData.videoUrl)"
                      type="video/mp4"
                    />
                    <source
                      :src="getVideoUrl(newData.videoUrl)"
                      type="video/webm"
                    />
                    Your browser does not support the video tag.
                  </video>
                  <img
                    :src="assetsPath + 'images/iphone-tablet-border.svg'"
                    alt=""
                    :class="$style.border"
                  />
                </div>
                <div
                  :class="[
                    $style.iPhoneModel,
                    showVideos ? '' : $style.hideBlackLayer,
                  ]"
                  id="iPhoneModel"
                  ref="iPhoneModel"
                >
                  <video
                    width="320"
                    height="240"
                    preload="auto"
                    muted
                    autoplay
                    loop
                    playsinline
                    :class="$style.videoPlayer"
                    :poster="getImgUrl(newData.cover)"
                    v-if="showVideos"
                  >
                    <source
                      :src="getVideoUrl(newData.videoUrl)"
                      type="video/mp4"
                    />
                    <source
                      :src="getVideoUrl(newData.videoUrl)"
                      type="video/webm"
                    />
                    Your browser does not support the video tag.
                  </video>
                  <img
                    :src="assetsPath + 'images/iphone-border.svg'"
                    alt=""
                    :class="$style.border"
                  />
                </div>
              </div>
            </div>
          </div>
          <h2 class="heading-2 mb-4 mt-5" v-html="featuredData.mainTitle" />
          <p class="mb-5">
            {{ featuredData.desp2 }}
          </p>
          <div class="d-flex justify-content-center" :class="$style.blackBadge">
            <div v-if="newData.appStore" :class="'ml-2'">
              <a
                target="_blank"
                :href="newData.appStore"
              >
                <AppleStore v-if="(isMobile && isIOS) || !isMobile" />
              </a>
            </div>
            <div v-if="newData.googlePlay" class="ml-2">
              <a
                target="_blank"
                :href="newData.googlePlay"
                v-if="newData.googlePlay"
              >
                <GooglePlay v-if="(isMobile && isAndroid) || !isMobile" />
              </a>
            </div>
            <div v-if="newData.amazonStore" class="ml-2">
              <a
                target="_blank"
                :href="newData.amazonStore"
                v-if="newData.amazonStore"
              >
                <AmazonStore v-if="!isMobile" v />
              </a>
            </div>
            <div v-if="newData.andrdiodStore" class="ml-2">
              <a
                target="_blank"
                :href="newData.andrdiodStore"
              >
                <img
                  class="andrdiodButton"
                  v-if="(isAndroid && isMobile) || !isMobile"
                  src="https://preview-web.xiongmaoboshi.com/resource/cms/image/Android-CN-1604486683752-834.jpg"
                />
              </a>
            </div>
          </div>
          <div
            class="d-flex justify-content-center align-items-center mt-4"
            :class="$style.awardTag"
            v-if="newData.awardImages"
          >
            <template v-for="(badge, index) in newData.awardImages">
              <div v-if="badge.image" :key="index">
                <img :src="getImgUrl(badge.image)" />
              </div>
            </template>
          </div>
        </div>
      </b-container>
    </div>
  </div>
</template>

<style lang="scss" module>
@import "@/design/_colors.scss";
@import "@/design/_fonts.scss";

.andrdiodButton {
  width: 200px;
  height: 72px;
  border-radius: 30px !important;
}

.numberPlaceholder {
  position: absolute;
  z-index: -1;
  left: 0;
  opacity: 0;
  visibility: hidden;
}
.homeHeroTrigger {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  min-height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1;
}
.homeHero {
  position: relative;
  height: 100vh;
  z-index: 1;
}

.heroContent {
  position: absolute;
  width: 730px;
  max-width: 100%;
  height: 227px;
  margin: auto;
  color: $white;
  z-index: 1;
  top: -100px;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  h1 {
    color: $white;
    font-size: 48px;
    margin-bottom: 30px;
  }
  p {
    font-size: 20px;
    margin-bottom: 40px;
  }
  .storeBadge {
    img {
      margin: 0 10px;
      width: 200px;
    }
  }
}
.learnPlay {
  padding: 40px 0;
  .centerBlock {
    width: 720px;
    max-width: 100%;
    margin: 0 auto;
  }
  .photos {
    width: 600px;
    max-width: 100%;
    margin: 0 auto;
    padding-bottom: 399px;
    position: relative;
    .iPadModel {
      position: absolute;
      width: 80.6%;
      top: 0;
      left: 0;
      border-radius: 10px;
      -webkit-border-radius: 10px;
      background-image: url("#{$assetsPath}images/learnPlayBackground@2x.jpg");
      background-position: center;
      background-size: cover;
      &:after {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.2);
        z-index: 1;
        border-radius: 10px;
        width: calc(100% - 25px);
        height: calc(100% - 10px);
        margin: auto;
      }
      &.hideBlackLayer {
        &::after {
          display: none;
        }
      }
      img {
        position: relative;
        z-index: 2;
      }
    }
    .iPhoneModel {
      position: absolute;
      width: 64%;
      bottom: 0;
      right: 0;
      left: 0;
      margin: 0 auto;
      overflow: hidden;
      transform-origin: center center;
      z-index: 11;
      border-radius: 10px;
      -webkit-border-radius: 10px;
      background-image: url("#{$assetsPath}images/learnPlayBackground@2x.jpg");
      background-position: center;
      background-size: cover;
      &:after {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.2);
        z-index: 1;
        border-radius: 10px;
        width: calc(100% - 25px);
        height: calc(100% - 10px);
        margin: auto;
      }
      &.hideBlackLayer {
        &::after {
          display: none;
        }
      }
      img {
        position: relative;
        z-index: 2;
      }
    }
  }
  .videoPlayer {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: calc(100% - 25px);
    height: calc(100% - 10px);
    object-fit: cover;
  }
}

.blackBadge {
  img {
    width: 200px;
  }
}
.awardTag {
  > div {
    width: 80px;
    margin: 0 20px;
    img {
      max-width: 100%;
    }
  }
}
@media only screen and (max-width: 767px) {
  .homeHero {
    height: 100vh;
  }
  .heroContent {
    h1 {
      font-size: 32px;
    }
  }
  .learnPlay {
    padding: 40px 0;
    .photos {
      padding-bottom: 67%;
      .iPhoneModel {
        &:after {
          width: calc(100% - 15px);
          height: calc(100% - 9px);
        }
      }
      .iPadModel {
        &:after {
          width: calc(100% - 15px);
          height: calc(100% - 9px);
        }
      }
    }
    .videoPlayer {
      width: calc(100% - 15px);
      height: calc(100% - 9px);
    }
  }
}
@media only screen and (max-width: 450px) {
  .heroContent {
    height: 297px;
    p {
      width: 300px;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .learnPlay {
    padding: 40px 0;
    .photos {
      .iPhoneModel {
        &:after {
          width: calc(100% - 10px);
          height: calc(100% - 7px);
        }
      }
      .iPadModel {
        &:after {
          width: calc(100% - 10px);
          height: calc(100% - 7px);
        }
      }
    }
    .videoPlayer {
      width: calc(100% - 10px);
      height: calc(100% - 7px);
    }
  }
}
</style>
